import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth-service.service';
import { environment } from 'src/environments/environment';
import { LoadingBarService } from 'src/app/services/loading-bar/loading-bar.service';
import { finalize } from 'rxjs/operators';

const urlsPartsToSkip = ['/afmstats', '/api/products/', '/flips/counters', '/flips/stats/history', '/flips/stats/live'];

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const loadingBarService = inject(LoadingBarService);
  const shouldSkip = urlsPartsToSkip.some((urlPart) => req.url.includes(urlPart));
  // Generate a unique ID for this request
  const reqId = 'http-' + Date.now() + '-' + Math.random().toString(36).slice(2);

  if (shouldSkip) {
    return next(req);
  }

  if (req.url.includes(environment.afmApis.topItems.baseUrl) || req.url.includes(environment.afmApis.be.baseUrl)) {
    const authService = inject(AuthService);
    const newReq = req.clone({
      headers: req.headers.append('Authorization', `Bearer ${authService.idToken() ?? ''}`),
    });
    loadingBarService.startLoading(reqId);
    return next(newReq).pipe(finalize(() => loadingBarService.stopLoading(reqId)));
  } else {
    loadingBarService.startLoading(reqId);
    return next(req).pipe(finalize(() => loadingBarService.stopLoading(reqId)));
  }
}

export function userIdInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const loadingBarService = inject(LoadingBarService);
  const reqId = 'http-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  if (req.url.includes(environment.afmApis.topItems.baseUrl) || req.url.includes(environment.afmApis.be.baseUrl)) {
    const authService = inject(AuthService);
    const newReq = req.clone({
      headers: req.headers.append('X-User-Id', authService.user()?.uid ?? ''),
    });
    loadingBarService.startLoading(reqId);
    return next(newReq).pipe(finalize(() => loadingBarService.stopLoading(reqId)));
  } else {
    loadingBarService.startLoading(reqId);
    return next(req).pipe(finalize(() => loadingBarService.stopLoading(reqId)));
  }
}
